import { get } from "lodash";
import Config from "../config.js";
import { createRequestOptions } from "./utils";

export default () =>
  Object.freeze({
    authUser: async (email, password) => {
      const options = createRequestOptions({
        email,
        password,
      });

      const result = await fetch(Config.serverUrl + "/AuthUser", options);
      const response = await result.json();

      return get(response, "response");
    },
    refreshUserAuth: async (refreshToken) => {
      const options = createRequestOptions({ refreshToken });

      const result = await fetch(Config.serverUrl + "/RefreshUserAuth", options);
      const response = await result.json();

      return get(response, "response");
    },
  });



// WEBPACK FOOTER //
// ./src/services/testAuth.js